export enum IntendedUsageType {
  REALTIME = 'REALTIME',
  ANALYTICS = 'ANALYTICS'
}



// WEBPACK FOOTER //
// ./src/app/models/enums/intended-usage-type.ts